// Timeline data - NAIRDC's journey and achievements
export const timeline = [
  {
    date: "May 2021",
    description: "Launch of Nairdc",
  },
  {
    date: "October 2021",
    description: "The Middle East Digital Transformation Award for Artificial Intelligence in Education during GITEX 2021",
  },
  {
    date: "November 2021",
    description: "Winning the first and third place in Ekhtiraai - \"My Invention\" competition under the patronage of His Excellency Ayman Tawfiq Al-Moayyed - Minister of Youth and Sports Affairs",
  },
  {
    date: "October 2022",
    description: "Middle East Technical Excellence Award for Best AI Applications in the Kingdom of Bahrain in GITEX 2022",
  },
  {
    date: "October 2022",
    description: "ICT Leadership Award - 42nd Gulf & Middle East Information Technology Exhibition and Conference (GITEX Global)",
  },
  {
    date: "November 2022",
    description: "Outstanding Contribution Award at Finnovex Awards in Kingdom of Saudi Arabia",
  },
  {
    date: "January 2023",
    description: "CIO Leadership",
  },
  {
    date: "May 2023",
    description: "Artificial Intelligence and Internet of Things Project - Government Sector to NAIRDC for the project of Electricity Monitoring Dashboard for ASRY company",
  },
  {
    date: "May 2023",
    description: "Best AI implementation during Government Tech in Dubai",
  },
  {
    date: "October 2023",
    description: "Excellence Award for the Best Use of Artificial Intelligence",
  },
  {
    date: "October 2023",
    description: "CXO ICT Leadership Award - 43rd Gulf and Middle East Information Technology Exhibition and Conference (GITEX Global)",
  },
  {
    date: "December 2023",
    description: "ISO 27001:2022 Information security management system Certification - Information security, cybersecurity and privacy protection international certification",
  },
  {
    date: "April 2024",
    description: "ISO 23053:2022 Certification - Framework for Artificial Intelligence (AI) Systems Using Machine Learning (ML) compliance certification",
  },
];
